import React, { useRef } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import {
  BUILDING_TYPE_ID,
  FORM_VALUES
} from '../../../../../utils/helpers/constants';
import { getCategoryValues } from '../../../../../utils/helpers/common';
import { Select } from '../../../../ui/Select';
import { Category } from '../../../../../graphql/types';
import { NewRadioButton } from '../../../../NewRadioButton';
import { SelectRefType } from '../../../../NewSearch/NewSearchBar/types';
import {
  SelectContentContainer,
  selectPopoverStyles,
  selectStyles
} from '../styled';
import { fillCategoriesWithData } from '../../../../../utils/helpers/fillCategoriesWithData';
import { generateDataStat } from '../../../../../utils/helpers/generateDataStat';
import useScreenSize from '../../../../../hooks/useScreenSize';

interface CategoriesSelectProps {
  categories: Category[];
}

export const CategoriesSelect: React.FC<CategoriesSelectProps> = ({
  categories
}) => {
  const { t } = useTranslation();
  const { change } = useForm();
  const { values } = useFormState();
  const { isSmall } = useScreenSize();
  const selectRef = useRef<SelectRefType>(null);

  const filledCategories = fillCategoriesWithData(categories, true);

  const onCategoryHandleClick = ({ name, id }: Category) => {
    change(FORM_VALUES.typeEstate, name);
    const newCategoryId =
      id === BUILDING_TYPE_ID.FLAT_ALL ? BUILDING_TYPE_ID.FLAT_NEW : id;
    change(FORM_VALUES.categoryId, newCategoryId);
    change(FORM_VALUES.categoryValues, getCategoryValues({ id, categories }));
    if (selectRef.current) {
      selectRef.current?.closePopover();
    }
  };

  const placeholder = `${t('new_search.type_estate')} *`;
  const value = values[FORM_VALUES.typeEstate];

  const isNewOrSecondaryFlat = [
    BUILDING_TYPE_ID.FLAT_NEW,
    BUILDING_TYPE_ID.FLAT_SECONDARY
  ].includes(values[FORM_VALUES.categoryId]);

  return (
    <Select
      ref={selectRef}
      width="100%"
      value={value}
      placeholder={placeholder}
      cypress="category-dropdown"
      styles={selectStyles}
      modalTitle={placeholder}
      valueTag="body_1"
      showModalHeaderBorder={false}
      popoverStyles={selectPopoverStyles}
      modalCypress="item-form-category"
      stat={generateDataStat('create_ad_step3_type', isSmall) || ''}
      isPlaceholderVisible
    >
      <SelectContentContainer>
        {filledCategories.map(item => {
          const isSelected =
            isNewOrSecondaryFlat && item.id === BUILDING_TYPE_ID.FLAT_ALL;

          return (
            <NewRadioButton
              key={item.id}
              data={item}
              cypress="cat-item"
              currentValue={values[FORM_VALUES.categoryId]}
              onChangeHandler={() => onCategoryHandleClick(item)}
              isSelected={isSelected}
            />
          );
        })}
      </SelectContentContainer>
    </Select>
  );
};
